import React, { useState, useCallback } from 'react';
import { GameStatePrivate, RoundResult } from '@shared/types';
import { GameTable } from '@/components/table/GameTable';
import Toast from '@/components/ui/Toast';
import socket from '@/socket';

interface GameScreenProps {
  state: GameStatePrivate;
  roundResult: RoundResult | null;
  onDismissResult: () => void;
  sessionKey: string;
}

export const GameScreen: React.FC<GameScreenProps> = ({
  state,
  roundResult,
  onDismissResult,
}) => {
  const [error, setError] = useState<string | null>(null);

  const showError = (msg: string) => {
    setError(msg);
    setTimeout(() => setError(null), 3500);
  };

  const handleDrawTile = useCallback(() => {
    socket.emit('game:drawTile', (res) => {
      if (!res.success) showError(res.error ?? 'Taş çekilemedi');
    });
  }, []);

  const handleDrawDiscard = useCallback(() => {
    socket.emit('game:drawDiscard', (res) => {
      if (!res.success) showError(res.error ?? 'Taş çekilemedi');
    });
  }, []);

  const handleDiscard = useCallback((tileId: string) => {
    socket.emit('game:discard', { tileId }, (res) => {
      if (!res.success) showError(res.error ?? 'Taş atılamadı');
    });
  }, []);

  const handleOpenMelds = useCallback((
    melds: { tileIds: string[] }[],
    discardTileId: string,
  ) => {
    socket.emit('game:openMelds', { melds, discardTileId }, (res) => {
      if (!res.success) showError(res.error ?? 'Açma yapılamadı');
    });
  }, []);

  const handleAddToMeld = useCallback((
    meldId: string,
    tileId: string,
    position: 'start' | 'end',
  ) => {
    socket.emit('game:addToMeld', { meldId, tileId, position }, (res) => {
      if (!res.success) showError(res.error ?? 'İşleme yapılamadı');
    });
  }, []);

  const handleSortTiles = useCallback((type: 'color' | 'number') => {
    socket.emit('game:sortTiles', { sortType: type });
  }, []);

  return (
    <>
      <GameTable
        state={state}
        onDrawTile={handleDrawTile}
        onDrawDiscard={handleDrawDiscard}
        onDiscard={handleDiscard}
        onOpenMelds={handleOpenMelds}
        onAddToMeld={handleAddToMeld}
        onSortTiles={handleSortTiles}
        roundResult={roundResult}
        onDismissResult={onDismissResult}
        error={error}
      />
      {error && (
        <Toast message={error} type="error" onDone={() => setError(null)} />
      )}
    </>
  );
};

export default GameScreen;
